module.exports = "<app-ss-parameter type=\"MIX\"></app-ss-parameter>"